import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon_add.png'


const _withScopeId = n => (_pushScopeId("data-v-9630312a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-select" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "user-select-modal__bd" }
const _hoisted_11 = { class: "user-select__left" }
const _hoisted_12 = { class: "user-select__left__hd" }
const _hoisted_13 = { class: "user-select__left__bd" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { style: {"margin-left":"6px"} }
const _hoisted_16 = { class: "user-select__right" }
const _hoisted_17 = { class: "user-select__right__hd" }
const _hoisted_18 = { class: "text-grey" }
const _hoisted_19 = { class: "text-grey" }
const _hoisted_20 = { class: "user-select__right__bd" }
const _hoisted_21 = { class: "selected-user__icon" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "selected-user__icon" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "selected-user__icon" }
const _hoisted_26 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_ant_icon = _resolveComponent("ant-icon")
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_user_search_select = _resolveComponent("user-search-select")
  const _component_user_outlined = _resolveComponent("user-outlined")
  const _component_fork_outlined = _resolveComponent("fork-outlined")
  const _component_vxe_column = _resolveComponent("vxe-column")
  const _component_vxe_table = _resolveComponent("vxe-table")
  const _component_a_tabs = _resolveComponent("a-tabs")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["user-content", {'is-error':_ctx.isError,'disabled':_ctx.disabled}])
        }, [
          _createElementVNode("div", {
            class: "user-list",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
          }, [
            (!_ctx.tempUsers.length&&!_ctx.tempRoles.length&&!_ctx.tempProjectRoles.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "请选择"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempProjectRoles, (role2) => {
                    return (_openBlock(), _createBlock(_component_a_tag, {
                      disabled: _ctx.disabled,
                      key: role2.id,
                      closable: !_ctx.disabled,
                      color: "blue",
                      onClose: _withModifiers($event => (_ctx.deleteSelectedProjectRole(role2.id)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ant_icon, { type: "TeamOutlined" }),
                        (role2.valName.length<10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(role2.valName), 1))
                          : (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 1,
                              title: role2.valName,
                              class: "append-to-body"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(role2.valName.slice(0,9)+'...'), 1)
                              ]),
                              _: 2
                            }, 1032, ["title"]))
                      ]),
                      _: 2
                    }, 1032, ["disabled", "closable", "onClose"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempRoles, (role) => {
                    return (_openBlock(), _createBlock(_component_a_tag, {
                      disabled: _ctx.disabled,
                      key: role.id,
                      closable: !_ctx.disabled,
                      color: "blue",
                      onClose: _withModifiers($event => (_ctx.deleteSelectedRole(role.id)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ant_icon, { type: "DeploymentUnitOutlined" }),
                        (role.name.length<10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(role.name), 1))
                          : (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 1,
                              title: role.name,
                              class: "append-to-body"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(role.name.slice(0,9)+'...'), 1)
                              ]),
                              _: 2
                            }, 1032, ["title"]))
                      ]),
                      _: 2
                    }, 1032, ["disabled", "closable", "onClose"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempUsers, (user) => {
                    return (_openBlock(), _createBlock(_component_a_tag, {
                      disabled: _ctx.disabled,
                      key: user.id,
                      closable: !_ctx.disabled,
                      color: "blue",
                      onClose: _withModifiers($event => (_ctx.deleteSelectedUser(user.id)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ant_icon, { type: "UserOutlined" }),
                        (user.name.length<10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(user.name), 1))
                          : (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 1,
                              title: user.name,
                              class: "append-to-body"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user.name.slice(0,9)+'...'), 1)
                              ]),
                              _: 2
                            }, 1032, ["title"]))
                      ]),
                      _: 2
                    }, 1032, ["disabled", "closable", "onClose"]))
                  }), 128))
                ], 64))
          ]),
          (_ctx.tempUsers.length < _ctx.maxCount)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "add-icon",
                type: "link",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
              }, _hoisted_7))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      class: "user-select-modal user-mod",
      width: "820px",
      onCancel: _ctx.cancelFn,
      onOk: _ctx.ok
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
        (_ctx.maxCount && _ctx.maxCount !== Infinity)
          ? (_openBlock(), _createElementBlock("small", _hoisted_8, "本次操作最多可选 " + _toDisplayString(_ctx.maxCount) + " 个员工", 1))
          : _createCommentVNode("", true),
        (_ctx.maxRoleCount && _ctx.maxRoleCount !== Infinity)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, "本次操作最多可选 " + _toDisplayString(_ctx.maxRoleCount) + " 个角色", 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_tabs, {
              activeKey: _ctx.activeKey,
              "onUpdate:activeKey": _cache[4] || (_cache[4] = $event => ((_ctx.activeKey) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: "项目角色",
                  forceRender: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_table_wrapper, {
                      ref: "tableRef2",
                      dataSource: _ctx.projectRoles,
                      onOnSelectionChange: _ctx.onSelectionChange2,
                      tableHeight: 400,
                      columns: _ctx.columns2
                    }, null, 8, ["dataSource", "onOnSelectionChange", "columns"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "2",
                  tab: "组织角色",
                  forceRender: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_table_wrapper, {
                      ref: "tableRef",
                      dataSource: _ctx.rolesData,
                      onOnSelectionChange: _ctx.onSelectionChange,
                      tableHeight: 400,
                      loading: _ctx.loading,
                      columns: _ctx.columns
                    }, null, 8, ["dataSource", "onOnSelectionChange", "loading", "columns"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "3",
                  tab: "员工",
                  forceRender: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_user_search_select, {
                        value: _ctx.userSearchId,
                        "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.userSearchId) = $event)),
                        class: "w100",
                        placeholder: "输入员工姓名关键字",
                        "activated-status": _ctx.activatedStatus,
                        "on-job": _ctx.onJob,
                        status: _ctx.status,
                        userState: _ctx.userStatus,
                        onSelect: _ctx.onUserSearchSelect
                      }, null, 8, ["value", "activated-status", "on-job", "status", "userState", "onSelect"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.visible)
                        ? (_openBlock(), _createBlock(_component_vxe_table, {
                            key: 0,
                            "show-header": false,
                            border: "none",
                            height: "350",
                            ref: "xTree",
                            "row-config": {keyField: 'id'},
                            "column-config": {resizable: true},
                            "tree-config": {transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasEmployee', loadMethod: _ctx.loadDepartment},
                            data: _ctx.treeData
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_vxe_column, {
                                field: "name",
                                title: "公司员工",
                                width: "260",
                                "tree-node": true
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(row.isLeaf&&!row.isDepartment?'is-leaf':''),
                                    onClick: $event => (_ctx.clickRow(row))
                                  }, [
                                    (row.isLeaf)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (!row.isDepartment)
                                            ? (_openBlock(), _createBlock(_component_user_outlined, { key: 0 }))
                                            : (_openBlock(), _createBlock(_component_fork_outlined, { key: 1 }))
                                        ], 64))
                                      : (_openBlock(), _createBlock(_component_fork_outlined, { key: 1 })),
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(row.name), 1)
                                  ], 10, _hoisted_14)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["tree-config", "data"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, "已选择的成员 （ " + _toDisplayString(_ctx.tempUsers.length) + " 个）", 1),
              _createElementVNode("span", _hoisted_19, "已选择的角色 （ " + _toDisplayString(_ctx.tempProjectRoles.length +_ctx.tempRoles.length) + " 个）", 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempProjectRoles, (item3) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item3.id,
                  class: "selected-user"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_ant_icon, { type: "TeamOutlined" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item3.valName), 1),
                  _createElementVNode("div", {
                    class: "selected-user__delete",
                    onClick: $event => (_ctx.deleteTempProjectRole(item3.id))
                  }, [
                    _createVNode(_component_ant_icon, { type: "CloseCircleOutlined" })
                  ], 8, _hoisted_22)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempRoles, (item2) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item2.id,
                  class: "selected-user"
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_ant_icon, { type: "DeploymentUnitOutlined" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item2.name), 1),
                  _createElementVNode("div", {
                    class: "selected-user__delete",
                    onClick: $event => (_ctx.deleteTempRole(item2.id))
                  }, [
                    _createVNode(_component_ant_icon, { type: "CloseCircleOutlined" })
                  ], 8, _hoisted_24)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempUsers, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "selected-user"
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_ant_icon, { type: "UserOutlined" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.name), 1),
                  _createElementVNode("div", {
                    class: "selected-user__delete",
                    onClick: $event => (_ctx.deleteTempUser(item.id))
                  }, [
                    _createVNode(_component_ant_icon, { type: "CloseCircleOutlined" })
                  ], 8, _hoisted_26)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}